// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekColumnSkeleton-moduleCalendarGridWeekColumnSkeleton__h6g6s Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "CalendarGridWeekColumnSkeleton" }
